import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { Box, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

const UsersData = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/users`,
          { headers: { Authorization: `Bearer ${user.accessToken}` } }
        );
        const formattedData = res.data.map((user, index) => ({
          id: index + 1,
          role: user.roles[0].roleName,
          firstName: user.demographicData.firstName || "N/A",
          lastName: user.demographicData.lastName || "N/A",
          email: user.email,
          mobile: user.username,
          gender: user.demographicData.gender || "N/A",
          education: user.demographicData.education || "N/A",
          occupation: user.demographicData.occupation || "N/A",
          age: user.demographicData.age || "N/A",
          city: user.demographicData.city || "N/A",
          durables: user.demographicData.durables || "N.A",
          //durables
          hasAC: user.demographicData.durables.includes("AC") || false,
          hasKitchenSink:
            user.demographicData.durables.includes("Kitchen_sink") || false,
          hasDiningTable:
            user.demographicData.durables.includes("Dining_table") || false,
          hasOven: user.demographicData.durables.includes("Oven") || false,
          hasRefrigerator:
            user.demographicData.durables.includes("Refrigerator") || false,
          hasFridge: user.demographicData.durables.includes("Fridge") || false,
          hasWashingMachine:
            user.demographicData.durables.includes("Washing_machine") || false,
          hasWaterFiltering:
            user.demographicData.durables.includes("Water_filtering") || false,
          hasTelephone:
            user.demographicData.durables.includes("Telephone") || false,
          hasPC: user.demographicData.durables.includes("PC") || false,
          hasMotorCars:
            user.demographicData.durables.includes("Motor_cars") || false,
          hasLaptop: user.demographicData.durables.includes("Laptop") || false,
          hasCamera: user.demographicData.durables.includes("Camera") || false,
          hasVideoCamera:
            user.demographicData.durables.includes("Video_camera") || false,
          hasCRTTv: user.demographicData.durables.includes("CRT_TV") || false,
          hasTv: user.demographicData.durables.includes("TV") || false,
          hasHomeCinema:
            user.demographicData.durables.includes("Home_cinema") || false,

          apps: user.demographicData.apps || "N.A",
          //apps
          hasOTT: user.demographicData.apps.includes("OTT") || false,
          hasMobileBanking:
            user.demographicData.apps.includes("Mobile_Banking") || false,
          hasTravel: user.demographicData.apps.includes("Travel") || false,
          hasTicketing:
            user.demographicData.apps.includes("Ticketing") || false,
          hasShopping: user.demographicData.apps.includes("Shopping") || false,
          hasSocialMedia:
            user.demographicData.apps.includes("Social_Media") || false,
          hasMusic: user.demographicData.apps.includes("Music") || false,
          hasFoodOrdering:
            user.demographicData.apps.includes("Food_Ordering") || false,
          hasGaming: user.demographicData.apps.includes("Gaming") || false,
          hasTrading: user.demographicData.apps.includes("Trading") || false,
          hasNews: user.demographicData.apps.includes("News") || false,
          hasPayment: user.demographicData.apps.includes("Payment") || false,
        }));
        setData(formattedData);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    };
    fetchUsers();
  }, []);

  const columns = [
    { field: "id", headerName: "Sr. No.", width: 100 },
    { field: "firstName", headerName: "First Name", width: 150 },
    { field: "lastName", headerName: "Last Name", width: 150 },
    { field: "email", headerName: "Email", width: 350 },
    { field: "mobile", headerName: "Mobile Number", width: 150 },
    { field: "gender", headerName: "Gender", width: 100 },
    { field: "education", headerName: "Education", width: 200 },
    { field: "occupation", headerName: "Occupation", width: 200 },
    { field: "age", headerName: "Age", width: 100 },
    { field: "city", headerName: "City", width: 250 },
    { field: "hasAC", headerName: "Air Conditioning", width: 150, renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>, },
    { field: "hasKitchenSink", headerName: "Kitchen Sink", width: 150, renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>, },
    { field: "hasDiningTable", headerName: "Dining Table", width: 150, renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>, },
    { field: "hasOven", headerName: "Microwave Oven", width: 150, renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>, },
    { field: "hasRefrigerator", headerName: "Refrigerator", width: 200, renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>, },
    { field: "hasFridge", headerName: "Fridge Freezer", width: 200, renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>, },
    { field: "hasWashingMachine", headerName: "Washing Machine", width: 150, renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>, },
    { field: "hasWaterFiltering", headerName: "Water Filtering", width: 150, renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>, },
    { field: "hasTelephone", headerName: "Telephone (landline)", width: 150, renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>, },
    { field: "hasPC", headerName: "PC/Desktop", width: 150, renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>, },
    { field: "hasMotorCars", headerName: "Motor Cars", width: 150, renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>, },
    { field: "hasLaptop", headerName: "Laptop", width: 150, renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>, },
    { field: "hasCamera", headerName: "Still Camera", width: 150, renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>, },
    { field: "hasVideoCamera", headerName: "Video Camera", width: 150, renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>, },
    { field: "hasCRTTv", headerName: "Colour TVs CRT", width: 150, renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>, },
    { field: "hasTv", headerName: "LCD/Plasma TV", width: 150, renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>, },
    { field: "hasHomeCinema", headerName: "Home Cinema", width: 200, renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>, },
    {
      field: "hasOTT",
      headerName: "OTT",
      width: 100,
      renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>,
    },
    {
      field: "hasMobileBanking",
      headerName: "Mobile Banking",
      width: 120,
      renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>,
    },
    {
      field: "hasTravel",
      headerName: "Travel",
      width: 100,
      renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>,
    },
    {
      field: "hasTicketing",
      headerName: "Ticketing",
      width: 100,
      renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>,
    },
    {
      field: "hasShopping",
      headerName: "Shopping",
      width: 100,
      renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>,
    },
    {
      field: "hasSocialMedia",
      headerName: "Social Media",
      width: 150,
      renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>,
    },
    {
      field: "hasMusic",
      headerName: "Music",
      width: 100,
      renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>,
    },
    {
      field: "hasFoodOrdering",
      headerName: "Food Ordering",
      width: 150,
      renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>,
    },
    {
      field: "hasGaming",
      headerName: "Gaming",
      width: 100,
      renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>,
    },
    {
      field: "hasTrading",
      headerName: "Share Trading",
      width: 120,
      renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>,
    },
    {
      field: "hasNews",
      headerName: "News",
      width: 100,
      renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>,
    },
    {
      field: "hasPayment",
      headerName: "Payment",
      width: 100,
      renderCell: (params) => <Box>{params.value ? "YES" : "NO"}</Box>,
    },
  ];

  const rows = data && data.filter((user) => user.role === "USER")

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {isLoading ? (
        <Typography sx={{ textAlign: "center", marginTop: "20px" }}>
          Loading...
        </Typography>
      ) : (
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10, 25, 50]}
          disableSelectionOnClick
        />
      )}
    </Box>
  );
};

export default UsersData;
